<script>
    import { Section } from "svelte-email";
    import { offset } from "@floating-ui/dom";

    import CTA from "$lib/Components/Order/CTA.svelte";

    import bgImage from "$lib/assets/images/order/pricing-bg-img.png";
    import broncoThumbnail from "$lib/assets/images/order/bronco.png";
    import camryThumbnail from "$lib/assets/images/order/camery.png";
    import cameroThumbnail from "$lib/assets/images/order/camero.png";
    import civicThumbnail from "$lib/assets/images/order/civic.png";
    import PaymentCard from "./PaymentCard.svelte";
    const repairCardsData = [
        {
            title: "Ford Bronco",
            image: broncoThumbnail,
            price: 732.83,
            description: "AC Condenser Repair",
        },
        {
            title: "Toyota Camry",
            image: camryThumbnail,
            price: 1242.78,
            description: "Oil Pump Replacement",
        },
        {
            title: "Chevy Camero",
            price: 943.21,
            image: cameroThumbnail,
            description: "Engine Gasket Replacement",
        },
        {
            title: "Honda Civic",
            price: 1028.35,
            image: civicThumbnail,
            description: "Exhause Pipe Repair",
        },
    ];
</script>

<section class="section-container">
    <div class="payment-container">
        <div class="left">
            <div class="snap-x scroll-px-4 snap-mandatory payment-cards scroll-smooth flex overflow-x-auto px-4 py-10">
                {#each repairCardsData as card}
                    <PaymentCard title={card.title} imageLink={card.image} price={card.price} description={card.description} />
                {/each}
            </div>
        </div>
        <div class="right">
            <CTA title="You might not expect it, but we do." isLight={false} btnColor="variant-filled-primary" titleFont="text-white" text="You never plan on having a costly repair, but with certification you don't have to. This is how being certified can cover you when it counts." button="Get Certified" />
        </div>
    </div>
</section>

<style>
    .payment-cards {
        scrollbar-gutter: none;
        scrollbar-width: none;
        gap: 1.75rem;
        padding-left: 50px;
    }
    section {
        @apply bg-secondary-500;
        background-image: url("$lib/assets/images/order/gradient-secondary-bg-4.png");
        /* background-blend-mode: multiply, normal; */
        /* backface-visibility: offset; */

        background-repeat: no-repeat;
        background-position: center;

        background-size: cover;
        background-position: left;

        display: flex;
        /* flex-direction: column; */
        justify-content: center;
        align-items: center;
        margin: auto;
        flex-grow: 1;
    }
    .payment-container {
        display: flex;
        flex-direction: column-reverse;
        justify-content: space-between;
        align-items: flex-start;
        margin: auto;
        width: 100%;

        margin: auto;
    }
    .right {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-items: center;

        height: 100%;
        margin: auto;
        flex-grow: 1;
        padding: 2rem;

        justify-content: center;
    }

    .left {
        display: flex;
        flex-direction: column;
        width: 100%;
        overflow-x: scroll;

        gap: 1rem;
        max-width: 1200px;
        margin: auto;
        padding: 1rem;
        flex-grow: 1;
        /* padding: 2rem; */
    }
    .section-container {
        padding: 2rem 0;
    }
    @media screen and (min-width: 768px) {
        section {
            background-position: left;
            background-size: cover;
        }
        .payment-container {
            flex-direction: row-reverse;
        }
        .left {
            display: flex;
            width: 50%;
            padding: 2rem 0;
            min-width: none;
        }
        .right {
            width: 40%;
            min-height: 379px;
        }
    }
</style>
